import { render, staticRenderFns } from "./ProjectViewProjectItem.vue?vue&type=template&id=1ee75080"
import script from "./ProjectViewProjectItem.vue?vue&type=script&lang=ts"
export * from "./ProjectViewProjectItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee75080')) {
      api.createRecord('1ee75080', component.options)
    } else {
      api.reload('1ee75080', component.options)
    }
    module.hot.accept("./ProjectViewProjectItem.vue?vue&type=template&id=1ee75080", function () {
      api.rerender('1ee75080', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduler/itemComponents/ProjectViewProjectItem.vue"
export default component.exports